import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import Header from "@/components/shared/Header";
import Body from "@/components/shared/Body";

import Login from "@/components/login/Login";
import ExpiredPassword from "@/components/login/ExpiredPassword";

import Dashboard from "@/components/dashboard/Index";
import Admin from "@/components/admin/Index";
import Prodam from "@/components/prodam/Index";
import ServerData from "@/components/admin/Server";

import DemandCreate from "@/components/demands/Edit";
import DemandIndex from "@/components/demands/Index";
import DemandReport from "@/components/demands/Report";

import ContractIndex from "@/components/contracts/Index";
import ContractCreate from "@/components/contracts/Edit";
import ContractUpdate from "@/components/contracts/UpdateContract";

import TypeDemandIndex from "@/components/types/demand/Index";
import TypeDemandCreate from "@/components/types/demand/Edit";
import TypeApproverIndex from "@/components/types/approver/Index";
import TypeApproverCreate from "@/components/types/approver/Edit";

import SystemIndex from "@/components/systems/Index";
import SystemCreate from "@/components/systems/Edit";

import PersonIndex from "@/components/persons/Index";
import PersonCreate from "@/components/persons/Edit";

import DemandOwnerSubstitutionIndex from "@/components/demandOwnerSubstitutions/Index";
import DemandOwnerSubstitutionCreate from "@/components/demandOwnerSubstitutions/Edit";
import OfficeScoreIndex from "@/components/officesScore/Index";
import OfficeEvaluatedDemands from "@/components/officesScore/EvaluatedDemands";
import OfficeEvaluatedDemandComments from "@/components/officesScore/EvaluatedDemandComments";
import OfficeIndex from "@/components/offices/Index";
import OfficeCreate from "@/components/offices/Edit";

import AreaIndex from "@/components/areas/Index";
import AreaCreate from "@/components/areas/Edit";

import DemandBillingReport from "@/components/reports/DemandBilling";

import HttpError from "@/components/shared/HttpError";

Vue.use(VueRouter);

const defaultComponents = { default: Body, header: Header };

const router = new VueRouter({
    // Do not use history mode. Prodam's information security team
    // refuses to enable url rewrite in the server
    base: process.env.VUE_APP_ROUTE_BASE_URL,
    mode: "history",
    routes: [{
        path: "/login",
        components: { default: Login },
        name: "login"
    },
    {
        path: "/login",
        components: { default: Login },
        name: "logout"
    },
    {
        path: "/login/senhaExpirada",
        components: { default: ExpiredPassword },
        name: "expiredPassword"
    },
    {
        path: "/registrar/atualizar",
        components: { default: PersonCreate },
        name: "firstLogin"
    },
    {
        path: "/registrar/atualizar",
        components: { default: PersonCreate },
        name: "profileUpdateRequired"
    },
    {
        path: "/dashboard",
        components: { default: Dashboard, header: Header },
        name: "dashboard"
    },
    {
        path: "/administracao",
        components: { default: Admin, header: Header },
        name: "admin"
    },
    {
        path: "/prodam",
        components: { default: Prodam, header: Header },
        name: "prodam"
    },
    {
        path: "/reports",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: DemandBillingReport,
            name: "demandBillingReport"
        }]
    },
    {
        path: "/serverData",
        components: { default: ServerData, header: Header },
        name: "serverData"
    },
    {
        path: "/areas",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: AreaIndex,
            name: "areaIndex"
        },
        {
            path: "nova",
            component: AreaCreate,
            name: "areaCreate"
        },
        {
            path: ":id",
            component: AreaCreate,
            name: "areaEdit"
        }
        ]
    },
    {
        path: "/contratos",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: ContractIndex,
            name: "contractIndex"
        },
        {
            path: "novo",
            component: ContractCreate,
            name: "contractCreate"
        },
        {
            path: ":id",
            component: ContractCreate,
            name: "contractEdit"
        },
        {
            path: "novo/:id",
            component: ContractCreate,
            name: "contractCopy"
        },
        {
            path: "atualizar/:id",
            component: ContractUpdate,
            name: "contractUpdate"
        }
        ]
    },
    {
        path: "/demandas",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: DemandIndex,
            name: "demandIndex"
        },
        {
            path: "relatorio",
            component: DemandReport,
            name: "demandReport"
        },
        {
            path: "nova",
            component: DemandCreate,
            name: "demandCreate"
        },
        {
            path: ":id",
            component: DemandCreate,
            name: "demandEdit"
        }
        ]
    },
    {
        path: "/secretarias",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: OfficeIndex,
            name: "officeIndex"
        },
        {
            path: "nova",
            component: OfficeCreate,
            name: "officeCreate"
        },
        {
            path: ":id",
            component: OfficeCreate,
            name: "officeEdit"
        }
        ]
    },
    {
        path: "/avaliacao-secretarias",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: OfficeScoreIndex,
            name: "officeScoreIndex"
        },
        {
            path: ":officeId",
            component: OfficeEvaluatedDemands,
            name: "officeEvaluatedDemands"
        },
        {
            path: "evaluatedDemandComments/:demandId",
            component: OfficeEvaluatedDemandComments,
            name: "officeEvaluatedDemandComments"
        }

        ]
    },
    {
        path: "/tipo-aprovador",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: TypeApproverIndex,
            name: "typeApproverIndex"
        },
        {
            path: "novo",
            component: TypeApproverCreate,
            name: "typeApproverCreate"
        },
        {
            path: ":id",
            component: TypeApproverCreate,
            name: "typeApproverEdit"
        }
        ]
    },
    {
        path: "/tipo-demanda",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: TypeDemandIndex,
            name: "typeDemandIndex"
        },
        {
            path: "novo",
            component: TypeDemandCreate,
            name: "typeDemandCreate"
        },
        {
            path: ":id",
            component: TypeDemandCreate,
            name: "typeDemandEdit"
        }
        ]
    },
    {
        path: "/sistemas",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: SystemIndex,
            name: "systemIndex"
        },
        {
            path: "nova",
            component: SystemCreate,
            name: "systemCreate"
        },
        {
            path: ":id",
            component: SystemCreate,
            name: "systemEdit"
        }
        ]
    },
    {
        path: "/usuarios",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: PersonIndex,
            name: "personIndex"
        },
        {
            path: "nova",
            component: PersonCreate,
            name: "personCreate"
        },
        {
            path: ":id",
            component: PersonCreate,
            name: "personEdit"
        }
        ]
    },
    {
        path: "/substituicoes",
        components: { ...defaultComponents },
        children: [{
            path: "",
            component: DemandOwnerSubstitutionIndex,
            name: "demandOwnerSubstitutionIndex"
        },
        {
            path: "nova",
            component: DemandOwnerSubstitutionCreate,
            name: "demandOwnerSubstitutionCreate"
        },
        {
            path: ":id",
            component: DemandOwnerSubstitutionCreate,
            name: "demandOwnerSubstitutionEdit"
        }
        ]
    },
    // Errors
    {
        path: "/erro/:id",
        components: { default: HttpError },
        name: "httpError"
    },

    // Redirection
    {
        path: "*",
        redirect: { name: "dashboard" }
    }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        if (to.hash) {
            return { selector: to.hash };
        }

        return { x: 0, y: 0 };
    }
});

router.beforeEach(async (to, from, next) => {
    if (to.name === "httpError" || to.name === "expiredPassword") {
        next();
        return;
    }

    if (to.name === "login" || to.name === "logout") {
        store.dispatch("logout");
        next();
        return;
    }

    if (!store.getters.isLoggedIn) {
        next({ name: "login" });
        return;
    }

    if (store.getters.isStoreEmpty) {
        await store.dispatch("initialize");
    }

    if (to.name !== "firstLogin" && store.getters.isFirstLogin) {
        const person = store.getters.profile.person;
        next({ name: "firstLogin", params: { id: person.id } });
        return;
    }

    if (
        to.name !== "profileUpdateRequired" &&
        store.getters.isPersonUpdateRequired
    ) {
        const person = store.getters.profile.person;
        next({ name: "profileUpdateRequired", params: { id: person.id } });
        return;
    }

    store.dispatch("setRoute", { to, from });
    next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js